import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./index.css";
import AboutMeApp from "./AboutMeApp";
import DatenschutzPage from "./components/pages/datenschutz/DatenschutzPage";
import BlogPage from "./components/pages/blog/BlogPage";
import HeaderContainer from "./components/header/HeaderContainer";
import FooterContainer from "./components/footer/FooterContainer";
import ImpressumPage from "./components/pages/impressum/ImpressumPage";
import NotFoundPage from "./components/pages/not-found/NotFoundPage";
import useTheme from "./lib/theme/useTheme";

const CvPage = lazy(() => import("./components/pages/cv/CvPage"));

function AppShell() {
  const location = useLocation();
  const isHomeRoute = location.pathname === "/";
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="min-h-screen theme-page">
      <div className="mx-auto flex min-h-screen w-full max-w-screen-3xl flex-col gap-5 px-4 py-5 sm:px-6 sm:py-6 lg:gap-6 lg:px-8 4xl:max-w-[1800px] 5xl:max-w-[2200px] 6xl:max-w-[2600px]">
        <header>
          <HeaderContainer theme={theme} onToggleTheme={toggleTheme} />
        </header>
        <main
          className={`flex flex-1 items-start ${
            isHomeRoute ? "lg:items-center" : "lg:items-start"
          }`}
        >
          <Routes>
            <Route path="/" element={<AboutMeApp />} />
            <Route
              path="/cv"
              element={
                <Suspense
                  fallback={
                    <section className="w-full py-4 text-sm theme-text-muted">
                      Loading CV viewer...
                    </section>
                  }
                >
                  <CvPage />
                </Suspense>
              }
            />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <footer>
          <FooterContainer />
        </footer>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}
export default App;
